virtual function void write({{ subscribedTransactionHandle.type }} t);
{{#if (not subclasses.length)}}
  cg.sample(t);
{{/if}}
endfunction
